import React from 'react';

import CustomSelectMultipleOptions from 'components/elements/CustomSelectMultipleOptions';

const LabeledCustomSelectMultiple = ({ required, containerHeight, ...rest }) => {
  return <CustomSelectMultipleOptions {...rest} />;
};

export default LabeledCustomSelectMultiple;
